import { request } from "./http";

export interface LicensedEntity {
  name: string;
  jurisdiction: string | null;
  regulatory_authority: string | null;
  license_number: string | null;
  compensation_scheme: string | null;
  complaints_email: string | null;
  terms_url: string | null;
  privacy_url: string | null;
  risk_warning_html: string | null;
}

export interface Branding {
  name: string | null;
  slug: string | null;
  branding: {
    primary_color?: string;
    accent_color?: string;
    logo_url?: string;
    favicon_url?: string;
    company_name?: string;
    /**
     * Phase 10C.8 — third-party live-chat widget config. Set per
     * tenant via AdminBranding; the embed loads on every page after
     * login.
     */
    chat_provider?: "crisp" | "intercom" | "zendesk" | "tawk";
    chat_id?: string;
  };
  matched_via: "default" | "slug" | "domain";
  /** Phase 10A.1 — null when the tenant hasn't completed compliance setup. */
  licensed_entity: LicensedEntity | null;
}

export const branding = {
  /** Resolution order: explicit slug → Host header (default in prod). */
  load: (slug?: string) =>
    request<Branding>(slug ? `/api/v1/branding?slug=${encodeURIComponent(slug)}` : "/api/v1/branding", {
      noAuth: true,
    }),
};
